module.exports = __webpack_public_path__ + "static/img/物联网控制系统.192d0fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/img/product-article/物联网控制系统.png
// module id = 656
// module chunks = 1